import b from 'b_';
import React from 'react';

import './lesson-passport__badge.scss';

export enum LESSON_PASSPORT_BADGE_THEME {
    GREEN = 'green',
}

interface Props {
    theme?: LESSON_PASSPORT_BADGE_THEME;
}

export const LessonPassportBadge = React.memo(({ theme = LESSON_PASSPORT_BADGE_THEME.GREEN }: Props) => {
    return <div className={b('lesson-passport', 'badge', { theme })} />;
});
